// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParsedFormResult } from './parsed-form-result';
import {
    ParsedFormResultFromJSON,
    ParsedFormResultFromJSONTyped,
    ParsedFormResultToJSON,
    ParsedFormResultToJSONTyped,
} from './parsed-form-result';

/**
 * 
 * @export
 * @interface ParseSpecResponse
 */
export interface ParseSpecResponse {
    /**
     * 
     * @type {string}
     * @memberof ParseSpecResponse
     */
    file_name: string;
    /**
     * 
     * @type {Array<ParsedFormResult>}
     * @memberof ParseSpecResponse
     */
    forms: Array<ParsedFormResult>;
    /**
     * 
     * @type {string}
     * @memberof ParseSpecResponse
     */
    parser: string;
    /**
     * 
     * @type {string}
     * @memberof ParseSpecResponse
     */
    parser_label: string;
    /**
     * 
     * @type {string}
     * @memberof ParseSpecResponse
     */
    study_id_from_file: string;
    /**
     * 
     * @type {number}
     * @memberof ParseSpecResponse
     */
    total_codelists: number;
    /**
     * 
     * @type {number}
     * @memberof ParseSpecResponse
     */
    total_forms: number;
    /**
     * 
     * @type {number}
     * @memberof ParseSpecResponse
     */
    total_rules: number;
    /**
     * 
     * @type {string}
     * @memberof ParseSpecResponse
     */
    upload_id: string;
}

/**
 * Check if a given object implements the ParseSpecResponse interface.
 */
export function instanceOfParseSpecResponse(value: object): value is ParseSpecResponse {
    if (!('file_name' in value) || value['file_name'] === undefined) return false;
    if (!('forms' in value) || value['forms'] === undefined) return false;
    if (!('parser' in value) || value['parser'] === undefined) return false;
    if (!('parser_label' in value) || value['parser_label'] === undefined) return false;
    if (!('study_id_from_file' in value) || value['study_id_from_file'] === undefined) return false;
    if (!('total_codelists' in value) || value['total_codelists'] === undefined) return false;
    if (!('total_forms' in value) || value['total_forms'] === undefined) return false;
    if (!('total_rules' in value) || value['total_rules'] === undefined) return false;
    if (!('upload_id' in value) || value['upload_id'] === undefined) return false;
    return true;
}

export function ParseSpecResponseFromJSON(json: any): ParseSpecResponse {
    return ParseSpecResponseFromJSONTyped(json, false);
}

export function ParseSpecResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParseSpecResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'file_name': json['file_name'],
        'forms': ((json['forms'] as Array<any>).map(ParsedFormResultFromJSON)),
        'parser': json['parser'],
        'parser_label': json['parser_label'],
        'study_id_from_file': json['study_id_from_file'],
        'total_codelists': json['total_codelists'],
        'total_forms': json['total_forms'],
        'total_rules': json['total_rules'],
        'upload_id': json['upload_id'],
    };
}

export function ParseSpecResponseToJSON(json: any): ParseSpecResponse {
    return ParseSpecResponseToJSONTyped(json, false);
}

export function ParseSpecResponseToJSONTyped(value?: ParseSpecResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file_name': value['file_name'],
        'forms': ((value['forms'] as Array<any>).map(ParsedFormResultToJSON)),
        'parser': value['parser'],
        'parser_label': value['parser_label'],
        'study_id_from_file': value['study_id_from_file'],
        'total_codelists': value['total_codelists'],
        'total_forms': value['total_forms'],
        'total_rules': value['total_rules'],
        'upload_id': value['upload_id'],
    };
}
